import { gisStats } from "@/mocks/gis";

export default function GisStatsBar() {
  const stats = [
    { label: "用户总数", value: gisStats.totalUsers.toLocaleString(), icon: "ri-user-3-line", color: "text-[#E8531A]", bg: "bg-[#E8531A]/10" },
    { label: "在线设备", value: gisStats.onlineDevices.toLocaleString(), icon: "ri-wifi-line", color: "text-green-600", bg: "bg-green-100" },
    { label: "离线设备", value: gisStats.offlineDevices.toLocaleString(), icon: "ri-wifi-off-line", color: "text-gray-500", bg: "bg-gray-100" },
    { label: "活跃告警", value: gisStats.activeAlarms.toLocaleString(), icon: "ri-alarm-warning-line", color: "text-red-500", bg: "bg-red-100" },
    { label: "调压站", value: gisStats.stations.toLocaleString(), icon: "ri-building-4-line", color: "text-blue-600", bg: "bg-blue-100" },
    { label: "管网里程", value: `${gisStats.pipelineKm} km`, icon: "ri-route-line", color: "text-purple-600", bg: "bg-purple-100" },
  ];

  return (
    <div className="flex items-center gap-3 flex-wrap">
      {stats.map((s, i) => (
        <div key={i} className="flex items-center gap-2 bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 border border-white/50">
          <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${s.bg}`}>
            <i className={`${s.icon} text-sm ${s.color}`}></i>
          </div>
          <div>
            <div className="text-xs text-gray-400 leading-none">{s.label}</div>
            <div className="text-sm font-bold text-gray-800 leading-tight">{s.value}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
